export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5094.a964415c.jpg";